// extracted by mini-css-extract-plugin
export default {"link":"HeaderLink_link__kGOTc","active":"HeaderLink_active__ii1-m"};